import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  projectId: "iltg-website-web",
  appId: "1:337163003557:web:2f49f160dd4eef6e220f4c",
  storageBucket: "iltg-website-web.firebasestorage.app",
  apiKey: "AIzaSyDSjHrevjjG8qr0fbKliKHalfDB1VDolMo",
  authDomain: "iltg-website-web.firebaseapp.com",
  messagingSenderId: "337163003557",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
